import { ISensitiveCitiesState, actionTypes } from 'src/ducks/sensitive-cities.duck';
import { IStatus } from 'src/libraries/thunk.library';

export const getSensitiveCitiesStatus = (
  state: ISensitiveCitiesState,
  action: keyof typeof actionTypes
): IStatus =>
  state.status[action] ?? {
    fetching: false,
    error: null,
  };
